export const state = () => ({
  available: null,
})
export const getters = {
  filterByJob(state) {
    const { available } = state
    return jobTitle =>
      !available
        ? []
        : available.filter(form => form.permissions.coachee.includes(jobTitle))
  },
}

export const mutations = {
  UPDATE_ROOT: (state, payload) => Object.assign(state, payload),
}

export const actions = {
  async fetchAvailable({ commit, state, rootState }, force) {
    if (!navigator.onLine) return false
    const { forms: offline } = rootState.offline
    if (offline.updating) return false
    if (offline.lastUpdate && !force) {
      const lastUpdate = new Date(offline.lastUpdate).getTime()
      const now = new Date().getTime()
      const diff = now - lastUpdate
      if (diff < 60000) return false
    }
    commit('offline/UPDATING', 'forms', { root: true })
    try {
      const response = await this.$axios.get('/v3/app/sync/forms')
      commit('UPDATE_ROOT', { available: response.data })
      commit('offline/UPDATE', 'forms', { root: true })
    } catch (e) {
      commit('offline/FAILED', 'forms', { root: true })
      $nuxt.$rollbar.error(e)
      return false
    }
    return true
  },
}
